import type { MenuItem } from '../types';
import { useI18n, localizeField } from '../i18n';

interface ItemCardProps {
  item: MenuItem;
  onSelect: (item: MenuItem) => void;
}

export function ItemCard({ item, onSelect }: ItemCardProps) {
  const { lang } = useI18n();
  const name = localizeField(item.name_i18n, item.name, lang);
  const description = localizeField(item.description_i18n, item.description, lang);
  return (
    <button type="button" className="hc-item-card" onClick={() => onSelect(item)}>
      {item.img_url && (
        <img className="hc-item-img" src={item.img_url} alt={name} loading="lazy" />
      )}
      <div className="hc-item-info">
        <h3 className="hc-item-name">{name}</h3>
        {description && (
          <p className="hc-item-desc">{description}</p>
        )}
      </div>
      <span className="hc-item-price">{Number(item.price).toFixed(2)} &euro;</span>
    </button>
  );
}
